import { gsap } from "gsap";

/**
 *
 * @param {HTMLElement | null} cursor
 */
export function appAnimateCursor(cursor) {
  if (cursor !== null) {
    gsap.set(cursor, { xPercent: -50, yPercent: -50 });

    const xTo = gsap.quickTo(cursor, "x", { duration: 0.6, ease: "power3" });
    const yTo = gsap.quickTo(cursor, "y", { duration: 0.6, ease: "power3" });

    window.addEventListener("mousemove", (e) => {
      xTo(e.clientX);
      yTo(e.clientY);
    });
  }
}
